module.exports = __webpack_public_path__ + "img/m11.5c944a94.jpg";